import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertToPercent'
})
export class ConvertToPercent implements PipeTransform {
  transform(input: number | string | null | undefined, position: number): string {
    let transformed = '';
    if (input) {
      const value = parseFloat(input.toString().replace(/,/g, ''));
      transformed = Number(value).toFixed(position) + '%';
    }
    return transformed;
  }
}
